import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetSpecialtiesSubSpecialtiesDentalGuide,
	GetSpecialtiesSubSpecialtiesDentalGuideModel,
	GetSpecialtiesSubSpecialtiesDentalGuideParams,
} from 'domain/usecases';

export class RemoteGetSpecialtiesSubSpecialtiesDentalGuide implements GetSpecialtiesSubSpecialtiesDentalGuide {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetSpecialtiesSubSpecialtiesDentalGuideModel>,
	) {}

	async get({
		signal,
		...params
	}: GetSpecialtiesSubSpecialtiesDentalGuideParams): Promise<GetSpecialtiesSubSpecialtiesDentalGuideModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
